import {
  GetDaysByUserQueryVariables,
  getRequestUserId
} from "@mc-intranet/shared";
import { RedmineClient, TimeEntriesByDay } from "@mediacross/redmine-api";
import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";

const REDMINE_API_KEY = process.env["NX_REDMINE_API_KEY"];
const REDMINE_API_URL = process.env["NX_REDMINE_API_URL"];
const NX_OLD_REDMINE_API_KEY = process.env["NX_OLD_REDMINE_API_KEY"];
const NX_OLD_REDMINE_API_URL = process.env["NX_OLD_REDMINE_API_URL"];
const NX_APP_API_DOMAIN =
  process.env["NX_APP_API_DOMAIN"] || "https://intra-api.mediacross.it";

// console.log("REDMINE_API_KEY", REDMINE_API_KEY);
// console.log("REDMINE_API_URL", REDMINE_API_URL);

type RedmineClientType = {
  client: "activities" | "request";
};

export const useGetTimeEntriesByDay = (
  body: GetDaysByUserQueryVariables & RedmineClientType
) => {
  const getTimeEntriesByDay = async (
    body: GetDaysByUserQueryVariables & RedmineClientType
  ) => {
    const { userId, startDate, endDate, client } = body;

    if (client === "activities") {
      const redmine = new RedmineClient(REDMINE_API_URL, REDMINE_API_KEY);
      return await redmine.getTimeEntriesByDay({
        user_id: userId,
        from: startDate,
        to: endDate
      });
    } else {
      const redmine = new RedmineClient(
        NX_OLD_REDMINE_API_URL,
        NX_OLD_REDMINE_API_KEY
      );
      const id = getRequestUserId(userId);

      return await redmine.getTimeEntriesByDay({
        user_id: id,
        from: startDate,
        to: endDate
      });
    }
  };

  return useQuery<TimeEntriesByDay[], any>(
    ["getTimeEntriesByDayFetch", { ...body }],
    () => getTimeEntriesByDay(body),
    {
      enabled: !!body.userId
    }
  );
};

export type ExpoPushNotificationParams = {
  title: string;
  body: string;
};

export const useSendPushNotification = () => {
  const sendPushNotification = async (params: ExpoPushNotificationParams) => {
    const { title, body } = params;

    const response = await axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      url: `${NX_APP_API_DOMAIN}/api/sendNotifications`,
      data: {
        title,
        body
      }
    });

    return response?.data;
  };

  return useMutation(sendPushNotification);
};

/**
 * Strapi 5 identifies users by documentId, but `updateUsersPermissionsUser`
 * still takes the numeric id: the REST `/api/users` route returns both.
 */
export const getNumericUserId = async (
  documentId: string,
  token?: string | null
): Promise<string> => {
  const response = await axios.get<Array<{ id?: number | null }>>(
    `${NX_APP_API_DOMAIN}/api/users`,
    {
      params: { "filters[documentId][$eq]": documentId, "fields[0]": "id" },
      headers: token ? { Authorization: `Bearer ${token}` } : undefined
    }
  );
  const id = response.data?.[0]?.id;
  if (id === null || id === undefined) {
    throw new Error(`User ${documentId} not found`);
  }
  return String(id);
};
